import { useEffect, useState } from 'react';
import {
  BlockStack,
  Card,
  InlineGrid,
  Page,
  ResourceItem,
  ResourceList,
  Text,
} from '@shopify/polaris';

import { api } from '@/api/client';

interface Stats {
  installs: number;
  active: number;
  uninstalled: number;
  paid: number;
  recent: Array<{ domain: string; installed_at: number; uninstalled_at: number | null }>;
}

const Stat = ({ label, value }: { label: string; value: number }) => (
  <Card>
    <BlockStack gap="100">
      <Text as="p" variant="heading2xl">
        {value}
      </Text>
      <Text as="p" tone="subdued">
        {label}
      </Text>
    </BlockStack>
  </Card>
);

export function DashboardPage() {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    void api<Stats>('/ops/api/dashboard/stats')
      .then(setStats)
      .catch(() => setStats(null));
  }, []);

  return (
    <Page title="Dashboard" subtitle="Test stores are excluded from every number here.">
      <BlockStack gap="400">
        <InlineGrid columns={{ xs: 2, md: 4 }} gap="300">
          <Stat label="Installs, all time" value={stats?.installs ?? 0} />
          <Stat label="Active now" value={stats?.active ?? 0} />
          <Stat label="Uninstalled" value={stats?.uninstalled ?? 0} />
          <Stat label="Paying" value={stats?.paid ?? 0} />
        </InlineGrid>

        <Card padding="0">
          <ResourceList
            resourceName={{ singular: 'shop', plural: 'shops' }}
            items={stats?.recent ?? []}
            renderItem={(s) => (
              <ResourceItem id={s.domain} onClick={() => {}}>
                <Text as="span" fontWeight="semibold">
                  {s.domain}
                </Text>
                <Text as="span" tone="subdued" variant="bodySm">
                  {' — '}
                  {new Date(s.installed_at * 1000).toLocaleDateString()}
                  {s.uninstalled_at ? ' · uninstalled' : ''}
                </Text>
              </ResourceItem>
            )}
          />
        </Card>
      </BlockStack>
    </Page>
  );
}
